import { useConfirm } from '@/shared/ui'
import { useTranslate } from '@/shared/lib'
import { useRemoveInventoryObjectFile } from './api'

export const useRemoveInventObjectFile = () => {
  const { show } = useConfirm()
  const { trs } = useTranslate()
  const { remove: objectFileRemove } = useRemoveInventoryObjectFile()

  const remove = (data: any, handler: Function) => {
    show({
      title: trs('itf.remove_file'),
      /* Удаляем объект из списка */
      confirmFunc: () => objectFileRemove(data).then(() => handler()),
    })
  }

  return { remove }
}
